
/* ---------- cursor glow ---------- */
(function(){
  const g=document.getElementById('cursorGlow');
  if(!g)return;
  let x=innerWidth/2,y=innerHeight/2,cx=x,cy=y;
  addEventListener('pointermove',e=>{x=e.clientX;y=e.clientY;});
  (function loop(){requestAnimationFrame(loop);cx+=(x-cx)*.12;cy+=(y-cy)*.12;g.style.left=cx+'px';g.style.top=cy+'px';})();
})();

/* ---------- nav scroll state ---------- */
(function(){
  const nav=document.getElementById('nav');
  if(!nav)return;
  const announce=document.querySelector('.announce');
  function place(){
    const ah = announce ? announce.offsetHeight : 0;
    nav.style.top = Math.max(ah - scrollY, 0) + 'px';
    nav.classList.toggle('scrolled', scrollY > 10);
  }
  addEventListener('scroll', place, {passive:true});
  addEventListener('resize', place);
  place();
})();

/* ---------- hero parallax (mouse + scroll) ---------- */
(function(){
  const media=document.getElementById('heroMedia');
  const hero=document.getElementById('hero');
  if(!hero||!media)return;
  const chips=hero.querySelectorAll('.chip');
  let tx=0,ty=0,mx=0,my=0;
  hero.addEventListener('pointermove',e=>{
    const r=hero.getBoundingClientRect();
    tx=(e.clientX-r.left)/r.width-.5;
    ty=(e.clientY-r.top)/r.height-.5;
  });
  hero.addEventListener('pointerleave',()=>{tx=0;ty=0;});
  (function loop(){
    requestAnimationFrame(loop);
    mx+=(tx-mx)*.06;my+=(ty-my)*.06;
    const sy=Math.min(scrollY,800);
    media.style.translate=`${mx*-24}px ${my*-16 + sy*.18}px`;
    chips.forEach(ch=>{
      const d=parseFloat(ch.dataset.depth)||30;
      ch.style.transform=`translate(${mx*d}px,${my*d - sy*(d/14)}px)`;
    });
  })();
})();

/* ---------- magnetic buttons ---------- */
(function(){
  document.querySelectorAll('.magnetic').forEach(el=>{
    let raf=null;
    el.addEventListener('pointermove',e=>{
      const r=el.getBoundingClientRect();
      const x=(e.clientX-r.left-r.width/2)*.28;
      const y=(e.clientY-r.top-r.height/2)*.34;
      cancelAnimationFrame(raf);
      raf=requestAnimationFrame(()=>{el.style.transform=`translate(${x}px,${y}px)`;});
    });
    el.addEventListener('pointerleave',()=>{
      cancelAnimationFrame(raf);
      el.style.transition='transform .45s cubic-bezier(.2,.7,.2,1.4)';
      el.style.transform='translate(0,0)';
      setTimeout(()=>el.style.transition='box-shadow .3s,background .3s',450);
    });
  });
})();

/* ---------- marquee dup ---------- */
(function(){const t=document.getElementById('mq1');if(t)t.innerHTML+=t.innerHTML;})();

/* ---------- reveals ---------- */
(function(){
  const io=new IntersectionObserver(es=>{
    es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});
  },{threshold:.12});
  document.querySelectorAll('.reveal').forEach((el,i)=>{
    el.style.transitionDelay=(i%3)*.09+'s';
    io.observe(el);
  });
})();

/* ---------- card tilt ---------- */
(function(){
  document.querySelectorAll('[data-tilt]').forEach(card=>{
    card.addEventListener('pointermove',e=>{
      const r=card.getBoundingClientRect();
      const x=(e.clientX-r.left)/r.width-.5;
      const y=(e.clientY-r.top)/r.height-.5;
      card.style.transform=`rotateY(${x*9}deg) rotateX(${-y*9}deg) translateZ(4px)`;
    });
    card.addEventListener('pointerleave',()=>{
      card.style.transform='rotateY(0) rotateX(0)';
      card.style.transition='transform .5s cubic-bezier(.2,.7,.2,1),border-color .3s,box-shadow .3s';
      setTimeout(()=>card.style.transition='border-color .3s,box-shadow .3s',500);
    });
  });
})();

/* ---------- animated counters ---------- */
(function(){
  const io=new IntersectionObserver(es=>{
    es.forEach(e=>{
      if(!e.isIntersecting)return;
      const el=e.target;io.unobserve(el);
      const target=parseFloat(el.dataset.count), dec=parseInt(el.dataset.dec||'0'), suf=el.dataset.suffix||'';
      const pre=el.dataset.dec?'★ ':'';
      const t0=performance.now();
      (function step(t){
        const p=Math.min((t-t0)/1400,1);
        const ease=1-Math.pow(1-p,3);
        el.textContent=pre+(target*ease).toFixed(dec)+suf;
        if(p<1)requestAnimationFrame(step);
      })(t0);
    });
  },{threshold:.6});
  document.querySelectorAll('[data-count]').forEach(el=>io.observe(el));
})();



/* ---------- BOGO cart demo — real pairing, delegation, removable items ---------- */
(function(){
  let cartItems = [];
  const countEl = document.getElementById('cartCount');
  const toast = document.getElementById('bogoToast');
  const shipSpan = (document.getElementById('shipAway')||{}).parentElement;
  let toastTimer;
  function showToast(msg){
    if(!toast)return;
    toast.textContent = msg;
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(()=>toast.classList.remove('show'), 3200);
  }
  function unpairedPrice(){
    if(cartItems.length % 2 === 0) return 0;
    const s = cartItems.slice().sort((a,b)=>b-a);
    return s[s.length-1];
  }
  function subtotal(){
    const s = cartItems.slice().sort((a,b)=>b-a);
    let t = 0;
    s.forEach((v,i)=>{ t += (i%2===1) ? v/2 : v; });
    return t;
  }
  function renderPrices(){
    const up = unpairedPrice();
    document.querySelectorAll('.price[data-price]').forEach(p=>{
      const base = parseFloat(p.dataset.price);
      const compare = parseFloat(p.dataset.compare || (base+5));
      if(up > 0 && base <= up){
        const half = base/2;
        const pct = Math.round((1 - half/compare)*100);
        p.innerHTML = '<em class="pill">BOGO</em><em class="pill save">Save '+pct+'%</em><s>$'+base.toFixed(2)+'</s><span class="sale">$'+half.toFixed(2)+'</span>';
      } else {
        const pct = Math.round((1 - base/compare)*100);
        p.innerHTML = '<em class="pill">Sale</em><em class="pill save">Save '+pct+'%</em><s>$'+compare.toFixed(2)+'</s><span class="sale">$'+base.toFixed(2)+'</span>';
      }
      p.classList.remove('flash'); void p.offsetWidth; p.classList.add('flash');
    });
  }
  function updateShip(){
    const spent = Math.min(subtotal(), 999);
    const away = Math.max(49 - spent, 0);
    if(shipSpan){
      shipSpan.innerHTML = away === 0 ? '🎉 You unlocked <b>FREE shipping</b>!' : "You're <b>$"+away.toFixed(2)+"</b> from free shipping";
    }
    const fill = document.getElementById('shipFill');
    if(fill){ fill.style.width = Math.min(spent/49*100, 100) + '%'; fill.style.background = away === 0 ? 'linear-gradient(90deg,#1fa35c,#38c47a)' : ''; }
  }
  function refresh(){ if(countEl)countEl.textContent = cartItems.length; renderPrices(); updateShip(); }
  renderPrices();
  document.addEventListener('click', function(e){
    if(window.__realCart) return;
    const btn = e.target.closest('.add-cart');
    if(!btn) return;
    btn.classList.remove('added'); void btn.offsetWidth; btn.classList.add('added');
    const priceEl = (btn.closest('.card') || btn.closest('.pd-grid') || document).querySelector('.price[data-price]');
    const price = priceEl ? parseFloat(priceEl.dataset.price) : 19.99;
    cartItems.push(price);
    refresh();
    const up = unpairedPrice();
    if(up > 0){ showToast('BOGO unlocked — anything $'+up.toFixed(2)+' or under is 50% off as your second piece.'); }
    else { showToast('Pair complete ✓ — add another to unlock 50% off again.'); }
  });
  document.addEventListener('mnj-remove', function(e){
    const i = cartItems.indexOf(e.detail);
    if(i >= 0) cartItems.splice(i, 1);
    refresh();
  });
})();



/* ---------- sticky sale bar (no countdown — permanent BOGO) ---------- */
(function(){
  const bar = document.getElementById('saleBar');
  if(bar)addEventListener('scroll', ()=>{
    bar.classList.toggle('show', scrollY > innerHeight * 0.9);
  }, {passive:true});
})();






/* ---------- REAL Shopify cart (AJAX — stay on page, flip prices like live site) ---------- */
(function(){
  function money(v){return '$'+v.toFixed(2);}
  const toast=document.getElementById('bogoToast'); let tt;
  function showToast(m){if(!toast)return;toast.textContent=m;toast.classList.add('show');clearTimeout(tt);tt=setTimeout(()=>toast.classList.remove('show'),3400);}
  function flip(disc){
    document.querySelectorAll('.price[data-price]').forEach(p=>{
      const base=parseFloat(p.dataset.price); const comp=parseFloat(p.dataset.compare||base);
      if(disc && base<=disc+0.001){
        const half=Math.round(base*50)/100; const ref=Math.max(comp,base); const pct=Math.round((1-half/ref)*100);
        p.innerHTML='<em class="pill">BOGO</em><em class="pill save">Save '+pct+'%</em><s>'+money(base)+'</s><span class="sale">'+money(half)+'</span>';
      } else if(comp>base){
        const pct=Math.round((1-base/comp)*100);
        p.innerHTML='<em class="pill">Sale</em><em class="pill save">Save '+pct+'%</em><s>'+money(comp)+'</s><span class="sale">'+money(base)+'</span>';
      } else {
        p.innerHTML='<span class="sale">'+money(base)+'</span>';
      }
      p.classList.remove('flash'); void p.offsetWidth; p.classList.add('flash');
    });
  }
  function sync(cart){
    const c=document.getElementById('cartCount'); if(c)c.textContent=cart.item_count;
    const away=Math.max(49-cart.total_price/100,0);
    const s=document.getElementById('shipAway');
    if(s){ if(away===0){ s.parentElement.innerHTML='🎉 You unlocked <b>FREE shipping</b>!'; } else { s.textContent='$'+away.toFixed(2); } }
    const f=document.getElementById('shipFill'); if(f){ f.style.width=Math.min((cart.total_price/100)/49*100,100)+'%'; f.classList.toggle('full', away===0); }
    flip(cart.item_count%2===1 ? Math.min.apply(null,cart.items.map(function(i){return i.original_price/100;})) : 0);
  }
  function refresh(){ return fetch('/cart.js').then(r=>r.json()).then(c=>{sync(c);return c;}); }
  function added(){ refresh().then(c=>{
    showToast(c.item_count%2===1 ? 'Added ✓ — BOGO unlocked: your next item is 50% off in cart!' : 'Added ✓ — pair complete. Add another to unlock 50% off again.');
  });}
  fetch('/cart.js').then(r=>{ if(!r.ok) throw 0; return r.json(); }).then(cart=>{
    window.__realCart = true;
    sync(cart);
    document.querySelectorAll('.add-cart[data-variant]').forEach(b=>{
      b.addEventListener('click', e=>{
        e.preventDefault();
        b.classList.remove('added'); void b.offsetWidth; b.classList.add('added');
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:parseInt(b.dataset.variant,10),quantity:1})})
          .then(r=>r.json()).then(added).catch(()=>showToast('Could not add — item may be sold out.'));
      });
    });
    document.querySelectorAll('form[action*="/cart/add"]').forEach(f=>{
      f.addEventListener('submit', e=>{
        e.preventDefault();
        fetch('/cart/add.js',{method:'POST',body:new FormData(f)})
          .then(r=>{ if(!r.ok) throw 0; return r.json(); }).then(added)
          .catch(()=>showToast('Could not add — pick an available option.'));
      });
    });
  }).catch(()=>{});
})();



/* ===== 3D FX PACK ===== */
(function(){
  var bar=document.createElement('div');bar.className='fx-progress';document.body.appendChild(bar);
  var hero=document.querySelector('.hero-media');
  function onScroll(){
    var d=document.documentElement;
    var y=d.scrollTop||document.body.scrollTop;
    var max=d.scrollHeight-d.clientHeight;
    bar.style.width=(max>0?y/max*100:0)+'%';
    if(hero){var k=Math.min(y,600)/600;hero.style.transform='scale('+(1.12-.12*k).toFixed(4)+')';}
  }
  addEventListener('scroll',onScroll,{passive:true});onScroll();
  var row=document.querySelector('.trend-row');
  if(row){
    var cards=row.querySelectorAll('.trend-card');
    var tick=false;
    function flow(){
      tick=false;
      var r=row.getBoundingClientRect(),cx=r.left+r.width/2;
      for(var i=0;i<cards.length;i++){
        var b=cards[i].getBoundingClientRect();
        var dx=(b.left+b.width/2-cx)/r.width;
        var img=cards[i].querySelector('.tc-img');
        if(img)img.style.transform='rotateY('+(-dx*28).toFixed(2)+'deg) scale('+(1-Math.min(Math.abs(dx),.5)*.18).toFixed(3)+')';
      }
    }
    function req(){if(!tick){tick=true;requestAnimationFrame(flow);}}
    row.addEventListener('scroll',req,{passive:true});
    addEventListener('resize',req);addEventListener('scroll',req,{passive:true});req();
  }
})();




/* ===== FX PACK 2 ===== */
(function(){
  // tap ripple
  document.addEventListener('pointerdown',function(e){
    var b=e.target.closest('.btn,.sb-btn');
    if(!b)return;
    var r=b.getBoundingClientRect(),d=Math.max(r.width,r.height);
    var sp=document.createElement('span');sp.className='fx-ripple';
    sp.style.cssText='width:'+d+'px;height:'+d+'px;left:'+(e.clientX-r.left-d/2)+'px;top:'+(e.clientY-r.top-d/2)+'px;';
    b.appendChild(sp);setTimeout(function(){sp.remove();},600);
  },{passive:true});
  // add-to-cart red burst
  document.addEventListener('click',function(e){
    var b=e.target.closest('.add-cart,.mini');
    if(!b)return;
    var r=b.getBoundingClientRect(),cx=r.left+r.width/2,cy=r.top+r.height/2;
    for(var i=0;i<9;i++){
      var a=Math.PI*2*i/9+Math.random()*.5, dist=34+Math.random()*26;
      var s=document.createElement('span');s.className='fx-spark';
      s.style.cssText='left:'+cx+'px;top:'+cy+'px;--dx:'+(Math.cos(a)*dist)+'px;--dy:'+(Math.sin(a)*dist)+'px;';
      document.body.appendChild(s);
      (function(el){setTimeout(function(){el.remove();},750);})(s);
    }
  },true);
  // cart glow when it has items
  var cc=document.getElementById('cartCount');
  if(cc){
    var pill=cc.closest('a,div,button')||cc.parentElement;
    var mo=new MutationObserver(function(){
      var n=parseInt(cc.textContent,10)||0;
      pill.classList.toggle('fx-cart-live',n>0);
    });
    mo.observe(cc,{childList:true,characterData:true,subtree:true});
  }
})();




/* ===== MOBILE MENU ===== */
(function(){
  var bg=document.getElementById('burger'),mm=document.getElementById('mMenu');
  if(!bg||!mm)return;
  bg.addEventListener('click',function(){mm.classList.toggle('open');bg.classList.toggle('open');});
  mm.addEventListener('click',function(e){if(e.target.closest('a')){mm.classList.remove('open');bg.classList.remove('open');}});
  addEventListener('hashchange',function(){mm.classList.remove('open');bg.classList.remove('open');});
})();




/* ===== CATEGORY ROW BUILDER ===== */
(function(){
  var trend=document.querySelectorAll('.trend-card');
  var hero=document.querySelector('.hero');
  if(!trend.length||!hero||document.getElementById('catRow'))return;
  var row=document.createElement('div');row.className='cat-row';row.id='catRow';
  var bi=document.querySelector('#lineup .card .thumb img');
  var html='<a class="cat-chip" href="/collections/top-sellers"><span class="cat-im">'+(bi?'<img src="'+bi.getAttribute('src')+'" alt="">':'<span class="cat-best">★</span>')+'</span><b>Best Sellers</b></a>';
  trend.forEach(function(c){
    var img=c.querySelector('img'),lab=c.querySelector('.tc-label');
    if(!img||!lab)return;
    html+='<a class="cat-chip" href="'+c.getAttribute('href')+'"><span class="cat-im"><img src="'+img.getAttribute('src')+'" alt=""></span><b>'+lab.textContent+'</b></a>';
  });
  row.innerHTML=html;
  hero.parentNode.insertBefore(row,hero);
})();
(function(){
  var x=document.getElementById('mmClose'),mm=document.getElementById('mMenu'),bg=document.getElementById('burger');
  if(x&&mm){x.addEventListener('click',function(){mm.classList.remove('open');if(bg)bg.classList.remove('open');});}
})();




/* ===== CRO PACK ===== */
(function(){
  var grid=document.querySelector('#lineup .grid');
  if(grid){
    var order=['Non-Slip Satin Bonnet','Satin-Lined Beanie','Anime Durag','Rose Double Du For Long Locs'];
    order.slice().reverse().forEach(function(name){
      var card=Array.prototype.slice.call(grid.children).filter(function(c){
        var h=c.querySelector('h3');return h&&h.textContent.trim()===name;})[0];
      if(card)grid.insertBefore(card,grid.firstChild);
    });
  }
  var bar=document.createElement('div');bar.className='buy-bar';
  var pp=document.querySelector('.pd-price');
  var bbBase=pp?parseFloat(pp.dataset.price):null, bbComp=pp?parseFloat(pp.dataset.compare):null;
  var bbHtml=(bbBase!=null)?((bbComp>bbBase?'<s>$'+bbComp.toFixed(2)+'</s>':'')+'<b>$'+bbBase.toFixed(2)+'</b>'):'<b>Shop the sale</b>';
  bar.innerHTML='<div class="bb-price">'+bbHtml+'<em>BOGO 50% OFF</em></div><a class="btn add-cart" href="javascript:void(0)">Add to cart</a>';
  document.body.appendChild(bar);
  var form=document.querySelector('form[action*="/cart/add"]');
  if(form){
    document.body.classList.add('pd-mode');
    bar.querySelector('.add-cart').addEventListener('click',function(e){
      e.preventDefault();
      var sb=form.querySelector('[type=submit]');if(sb)sb.click();else form.submit();
    });
  } else {
    function upd(){document.body.classList.toggle('pd-mode',location.hash==='#product');}
    addEventListener('hashchange',upd);upd();
  }
})();


/* REAL cart drawer (v45) — renders /cart.js, qty via /cart/change.js, BOGO applied at checkout */
(function(){
  var chip=document.getElementById('cartChip'); if(!chip) return;
  var veil=document.createElement('div'); veil.className='cd-veil'; document.body.appendChild(veil);
  var d=document.createElement('aside'); d.className='cart-drawer'; d.setAttribute('aria-label','Cart');
  d.innerHTML='<div class="cd-head"><span>YOUR CART</span><button class="cd-close" aria-label="Close">✕</button></div><div class="cd-items"></div><div class="cd-recs"><div class="cd-recs-head">You may also like</div><div class="cd-recs-row"></div></div><div class="cd-foot"><div class="cd-bogo"></div><div class="cd-sub"><span>Subtotal</span><b class="cd-total">$0.00</b></div><div class="cd-ship"></div><span class="cd-track"><i class="cd-fill"></i></span><a class="btn dark" href="/checkout">Checkout</a><div class="cd-note">BOGO 50% off + shipping calculated at checkout.</div></div>';
  document.body.appendChild(d);
  function money(c){return '$'+(c/100).toFixed(2);}
  function render(cart){
    var box=d.querySelector('.cd-items');
    if(!cart.items.length){ box.innerHTML='<div class="cd-empty">Your cart is empty.<br>Add one — the second is 50% off.</div>'; }
    else{
      box.innerHTML=cart.items.map(function(it,i){
        return '<div class="cd-row" data-line="'+(i+1)+'">'+
          '<a href="'+(it.url||'#')+'"><img src="'+(it.image||'')+'" alt=""></a>'+
          '<div class="cd-info"><a href="'+(it.url||'#')+'" style="color:inherit;text-decoration:none">'+it.product_title+'</a>'+
            (it.variant_title&&it.variant_title!=='Default Title'?'<span class="cd-var">'+it.variant_title+'</span>':'')+
            '<div class="cd-qty"><button class="cd-dec" aria-label="Less">−</button><b>'+it.quantity+'</b><button class="cd-inc" aria-label="More">+</button></div>'+
          '</div>'+
          '<span class="cd-price">'+(it.original_line_price>it.final_line_price?'<s>'+money(it.original_line_price)+'</s>':'')+money(it.final_line_price)+'</span>'+
          '<button class="cd-rm" aria-label="Remove">✕</button>'+
        '</div>';
      }).join('');
    }
    d.querySelector('.cd-total').textContent=money(cart.total_price);
    var away=Math.max(49-cart.total_price/100,0);
    d.querySelector('.cd-ship').innerHTML = away===0 ? '🎉 You unlocked <b>FREE shipping</b>!' : 'You’re <b>$'+away.toFixed(2)+'</b> from free shipping';
    d.querySelector('.cd-note').textContent=(away===0?'Free shipping ✓ Taxes at checkout.':'Shipping $6.99 · free over $49');var cdf=d.querySelector('.cd-fill'); if(cdf){ cdf.style.width=Math.min((cart.total_price/100)/49*100,100)+'%'; cdf.classList.toggle('full', away===0); }
    var pairs=Math.floor(cart.item_count/2);
    d.querySelector('.cd-bogo').textContent = cart.item_count===0 ? '' : (cart.item_count%2===1 ? 'Add 1 more — the cheaper one is 50% off.' : (cart.total_discount>0 ? 'BOGO applied ✓ You saved '+money(cart.total_discount)+'.' : ''));
    var cc=document.getElementById('cartCount'); if(cc)cc.textContent=cart.item_count;
  }
  var recsCache=null;
  function renderRecs(cart){
    var wrap=d.querySelector('.cd-recs'), row=d.querySelector('.cd-recs-row');
    if(!wrap||!row) return;
    function paint(){
      var inCart={}; cart.items.forEach(function(it){ inCart[it.product_id]=1; });
      var odd = cart.item_count%2===1; var minP=cart.items.length?Math.min.apply(null,cart.items.map(function(i){return i.original_price/100;})):0;
      var picks=recsCache.filter(function(p){ return !inCart[p.id] && p.variants && p.variants.length; }).slice(0,4);
      if(!picks.length){ wrap.style.display='none'; return; }
      wrap.style.display='block';
      d.querySelector('.cd-recs-head').innerHTML = odd ? 'Complete your pair — 2nd piece <b style="color:#e0342c">50% off</b>' : 'You may also like';
      row.innerHTML=picks.map(function(p){
        var img=(p.images&&p.images[0]&&(p.images[0].src||p.images[0]))||'';
        var price=parseFloat(p.variants[0].price);
        var priceHtml = (odd && price<=minP+0.001) ? '<s>$'+price.toFixed(2)+'</s> <b style="color:#e0342c">$'+(Math.round(price*50)/100).toFixed(2)+'</b>' : '<b>$'+price.toFixed(2)+'</b>';
        var sw=p.variants.filter(function(v){return v.featured_image&&v.featured_image.src;}).slice(0,3);
        var swHtml='';
        if(p.variants.length>1&&sw.length){
          swHtml='<span class="pswat">'+sw.map(function(v){var s=v.featured_image.src;return '<img src="'+s+(s.indexOf('?')>-1?'&':'?')+'width=60" alt="">';}).join('')+(p.variants.length>sw.length?'<b>+'+(p.variants.length-sw.length)+'</b>':'')+'</span>';
        }
        return '<div class="cd-rec"><a href="/products/'+p.handle+'"><img src="'+img+'" alt=""></a><span class="cd-rec-t">'+p.title+'</span>'+swHtml+'<span class="cd-rec-p">'+priceHtml+'</span><button class="cd-rec-add" data-variant="'+p.variants[0].id+'">Add</button></div>';
      }).join('');
    }
    if(recsCache){ paint(); return; }
    fetch('/collections/top-sellers/products.json?limit=8').then(function(r){return r.json();}).then(function(j){
      recsCache=(j&&j.products)||[]; paint();
    }).catch(function(){ wrap.style.display='none'; });
  }
  function load(){ return fetch('/cart.js').then(function(r){return r.json();}).then(function(c){render(c);renderRecs(c);return c;}); }
  function change(line,qty){ fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:line,quantity:qty})}).then(function(r){return r.json();}).then(render); }
  function open(){ load(); d.classList.add('open'); veil.classList.add('open'); }
  function close(){ d.classList.remove('open'); veil.classList.remove('open'); }
  chip.style.cursor='pointer';
  chip.addEventListener('click',open);
  veil.addEventListener('click',close);
  d.querySelector('.cd-close').addEventListener('click',close);
  d.addEventListener('click',function(e){
    var row=e.target.closest('.cd-row'); if(!row) return;
    if(e.target.closest('a')) return;
    var line=parseInt(row.dataset.line,10);
    var q=parseInt(row.querySelector('.cd-qty b').textContent,10);
    if(e.target.closest('.cd-inc')) change(line,q+1);
    else if(e.target.closest('.cd-dec')) change(line,Math.max(q-1,0));
    else if(e.target.closest('.cd-rm')) change(line,0);
  });
  d.addEventListener('click',function(e){
    var b=e.target.closest('.cd-rec-add'); if(!b) return;
    b.textContent='✓';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:parseInt(b.dataset.variant,10),quantity:1})})
      .then(function(){ load(); setTimeout(function(){ b.textContent='Add'; },1200); });
  });
  /* open the drawer after any successful add for instant feedback */
  document.addEventListener('click',function(e){
    if(e.target.closest('.add-cart[data-variant]')) setTimeout(open,600);
  });
})();


/* ---------- email + SMS capture popup (v48) — once per 7 days, 8s delay ---------- */
(function(){
  return; /* old popup retired 2026-11-01: replaced by the Shopify Forms popup (records email + SMS consent) */
  if(/^\/(cart|checkout)/.test(location.pathname)) return; /* never interrupt checkout */
  try{
    if(localStorage.getItem('mnj_pop_until') > String(Date.now())) return;
  }catch(e){}
  (function(f){var d=0,n=0;function go(){if(d)return;d=1;removeEventListener('scroll',sc);f();}function sc(){if(scrollY>(document.documentElement.scrollHeight-innerHeight)*0.5)go();}try{n=+sessionStorage.getItem('mnj_pv')||0;sessionStorage.setItem('mnj_pv',n+1);}catch(e){}if(n>0)setTimeout(go,4000);else addEventListener('scroll',sc,{passive:true});})(function(){
    var veil=document.createElement('div'); veil.className='ep-veil';
    var box=document.createElement('div'); box.className='ep-box';
    box.innerHTML='<button class="ep-x" aria-label="Close">✕</button>'+
      '<div class="ep-img"><img src="https://cdn.shopify.com/s/files/1/0003/6395/4207/files/hf_20260721_193748_f3cd6446-112c-4086-9f47-c70cb5909c8b.png?v=1784664255&width=680" alt=""></div>'+
      '<div class="ep-inner">'+
      '<div class="ep-kick">MNJ SALES</div>'+
      '<div class="ep-step ep-s1">'+
        '<h3>10% OFF<br>your first order</h3>'+
        '<p>Join the list for your code, early drops, and restock alerts.</p>'+
        '<input type="email" class="ep-email" placeholder="Your email" autocomplete="email" required>'+
        '<button type="button" class="btn dark ep-go1">Get my 10% off</button>'+
        '<button class="ep-no">No thanks</button>'+
      '</div>'+
      '<div class="ep-step ep-s2" style="display:none">'+
        '<h3>Want it by text too?</h3>'+
        '<p>Drop your number for text-only deals and restock alerts.</p>'+
        '<input type="tel" class="ep-phone" placeholder="Phone number" autocomplete="tel">'+
        '<button type="button" class="btn dark ep-go2">Sign me up</button>'+
        '<button class="ep-no ep-skip">Skip — email is enough</button>'+
        '<div class="ep-legal">By signing up via text you agree to receive recurring automated marketing texts from MNJ Sales at the number provided. Consent is not a condition of purchase. Msg &amp; data rates may apply. Reply STOP to cancel.</div>'+
      '</div>'+
      '<div class="ep-step ep-s3" style="display:none">'+
        '<h3>You’re in ✔</h3>'+
        '<p>Here’s your code — tap to copy, it applies at checkout:</p>'+
        '<button type="button" class="ep-code" data-code="WELCOME10">WELCOME10</button>'+
        '<button type="button" class="btn dark ep-done">Keep shopping</button>'+
        '<div class="ep-legal">One use per customer. Can’t be combined with other discounts — checkout applies your best deal.</div>'+
      '</div>'+
      '</div>';
    veil.appendChild(box); document.body.appendChild(veil);
    requestAnimationFrame(function(){ veil.classList.add('show'); });
    function stamp(days){ try{ localStorage.setItem('mnj_pop_until', String(Date.now()+days*86400000)); }catch(e){} }
    function dismiss(){ veil.classList.remove('show'); setTimeout(function(){ veil.remove(); },350); }
    function show(step){ box.querySelectorAll('.ep-step').forEach(function(el){el.style.display='none';}); box.querySelector(step).style.display='block'; }
    function post(data){
      var fd=new FormData();
      Object.keys(data).forEach(function(k){ fd.append(k,data[k]); });
      return fetch('/contact',{method:'POST',body:fd});
    }
    box.querySelector('.ep-x').addEventListener('click',function(){ stamp(7); dismiss(); });
    box.querySelector('.ep-s1 .ep-no').addEventListener('click',function(){ stamp(7); dismiss(); });
    veil.addEventListener('click',function(e){ if(e.target===veil){ stamp(7); dismiss(); } });
    box.querySelector('.ep-go1').addEventListener('click',function(){
      var em=box.querySelector('.ep-email').value.trim();
      if(!em || em.indexOf('@')<1){ box.querySelector('.ep-email').focus(); return; }
      post({form_type:'customer',utf8:'✓','contact[email]':em,'contact[tags]':'newsletter,popup'});
      box.dataset.email=em; stamp(180); show('.ep-s3');
    });
    box.querySelector('.ep-go2').addEventListener('click',function(){
      var ph=box.querySelector('.ep-phone').value.trim();
      if(ph.replace(/\D/g,'').length < 10){ box.querySelector('.ep-phone').focus(); return; }
      post({form_type:'contact',utf8:'✓','contact[email]':box.dataset.email||'sms-only@popup.mnjsales.com','contact[phone]':ph,'contact[body]':'SMS OPT-IN from site popup. Phone: '+ph+' — agreed to recurring automated marketing texts (STOP to cancel).'});
      show('.ep-s3');
    });
    box.querySelector('.ep-skip').addEventListener('click',function(){ show('.ep-s3'); });
    box.querySelector('.ep-done').addEventListener('click',dismiss);
    box.querySelector('.ep-code').addEventListener('click',function(){
      var el=this;
      try{ navigator.clipboard.writeText(el.dataset.code).then(function(){ el.textContent='Copied ✓'; setTimeout(function(){ el.textContent=el.dataset.code; },1400); }); }catch(e){}
    });
  });
})();

